import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export const CONTROL_TABLE_STATE_STORAGE_KEY = "userControlList";

export const CONTROL_LIST_COLUMN_IDS = {
    CONTROL: "control",
    CONTROL_PROGRAM: "controlProgram",
    ASSIGNED_AS: "assignedAs",
    TAGS: "tags",
} as const;

export const controlListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [{ id: CONTROL_LIST_COLUMN_IDS.CONTROL_PROGRAM, desc: false }],
    };

export const controlListColumnFiltersCodecMap = {
    [CONTROL_LIST_COLUMN_IDS.CONTROL]: withModeCodec(encodedArrayCodec),
    [CONTROL_LIST_COLUMN_IDS.CONTROL_PROGRAM]: withModeCodec(encodedArrayCodec),
    [CONTROL_LIST_COLUMN_IDS.ASSIGNED_AS]: withModeCodec(encodedArrayCodec),
    [CONTROL_LIST_COLUMN_IDS.TAGS]: withModeCodec(encodedArrayCodec),
};
